<template>
  <Base
    :on-submit="(params) => reportsService.createFormTemplate(params)"
    :triger-prevent="trigerPrevent"
    field-details-route="field-details"
    templates-route="templates"
    ref="base"
  />
</template>

<script>
import { mapActions } from 'vuex';

import Base from '../base/base';

import { ReportsMixin } from '../../../../../mixins';

import { beforeRouteLeaveFunction } from '../base/common';

export default {
  title: 'NewCaseTempalte',
  components: { Base },
  mixins: [ReportsMixin],
  beforeRouteLeave(to, from, next) {
    const changed = this.$refs.base.exit();
    return beforeRouteLeaveFunction(to, from, next, this.disablePrevent, this.$translate, changed, this.clearTemplates);
  },
  data() {
    return {
      disablePrevent: false,
    };
  },
  ...mapActions({ clearTemplates: 'template/clearTemplates' }),
  methods: {
    trigerPrevent: function (value) {
      this.disablePrevent = value;
    },
  },
};
</script>
